import React from "react";

export default function ManualRow({
  selectedRow,
  rowData,
  rowIndex,
  updateFunc,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */
  const UpdateRowValueByRowIndex = (value) => {
    let _rowData = JSON.parse(JSON.stringify(rowData));
    selectedRow.rowValues.customHeader = value;
    _rowData[rowIndex] = selectedRow;
    updateFunc((prev) => _rowData);
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div className="row mb-2">
      <div className="col-md-12">
        <input
          type="text"
          value={selectedRow?.rowValues?.customHeader || ""}
          onChange={(e) => {
            const newValue = e.target.value;
            UpdateRowValueByRowIndex(newValue);
          }}
          name="customHeader"
          placeholder="Enter Value"
          className="form-control form-control-sm"
        />
      </div>
    </div>
  );
}
